import { cn } from '@/lib/utils';
import Image from 'next/image';

type CircledAvatarProps = React.ComponentProps<'div'> & {
  image?: string;
  name: string;
  size?: 'small' | 'medium' | 'large';
};

export default function CircledAvatar({
  image,
  name,
  size = 'medium',
  ...props
}: CircledAvatarProps) {
  const styles = {
    small: 'h-4 w-4 min-h-4 min-w-4 text-xs',
    medium: 'h-12 w-12 min-h-12 min-w-12 text-lg',
    large: 'h-[96px] w-[96px] min-h-[96px] min-w-[96px] text-4xl',
  };

  const firstLetter = name.charAt(0).toUpperCase();

  // Use higher resolution for better quality
  const width = size === 'small' ? 80 : size === 'medium' ? 120 : 200;
  const height = size === 'small' ? 80 : size === 'medium' ? 120 : 200;

  return (
    <div
      className={cn(
        'flex items-center justify-center overflow-hidden rounded-full bg-gray-100 font-medium text-gray-600',
        styles[size],
        props.className
      )}
      style={{ borderRadius: '50%' }}
      {...props}
    >
      {image ? (
        <Image
          src={image}
          alt={name}
          width={width}
          height={height}
          className='h-full w-full rounded-full object-cover'
          quality={95}
          priority={false}
          unoptimized={false}
        />
      ) : (
        <span className='flex h-full w-full select-none items-center justify-center font-semibold'>
          {firstLetter}
        </span>
      )}
    </div>
  );
}
